import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { isMobile } from "react-device-detect";

const TopBack = () => {
	let history = useHistory();
	const dispatch = useDispatch();
	const [strickyTop, setStickyTop] = useState(false);

	const renewalData = useSelector((state) => state.RenewalData);

	useEffect(() => {
		dispatch({
			type: "SET_MIDDLEMAN_DATA",
			payload: renewalData,
		});
	}, []);

	const cancelChanges = () => {
		dispatch({
			type: "RESTORE_MIDDLEMAN_STATE",
		});
		history.goBack();
	};

	useEffect(() => {
		if (isMobile) {
			if (typeof window !== "undefined") {
				window.addEventListener("scroll", () =>
					setStickyTop(window.pageYOffset > 98)
				);
			}
		}
	}, []);

	return (
		<div className={`general mt-4 ${strickyTop ? "sticky-top" : ""}`}>
			<a className="" onClick={() => cancelChanges()}>
				<div className="d-flex mt-2">
					<i className="bi bi-chevron-left i1"></i>
					<h4 className="ml-2" style={{ color: "#00778A" }}>
						BACK TO MY COVERAGE
					</h4>
				</div>
			</a>
		</div>
	);
};

export default TopBack;
